module.exports = __webpack_public_path__ + "img/Pic_TB_C.c27f4ba1.png";